import * as React from 'react';
import { Provider } from 'react-redux';
import ThemeProvider from '@material-ui/styles/ThemeProvider';

import { GoogleAnalytics } from 'modules/analytics/components/GoogleAnalytics';

import defaultTheme from 'modules/presentation/themes/defaultTheme';
import { PubDocsRouter } from './components/PubDocsRouter';
import { Routes as PubDocsRoutes } from './routes';
import store from './store';

export const App: React.SFC = () => {
  React.useEffect(() => {
    const originalBodyOverflow = document.body.style.overflow;
    const originalHtmlOverflow = document.documentElement.style.overflow;

    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';

    return () => {
      document.body.style.overflow = originalBodyOverflow;
      document.documentElement.style.overflow = originalHtmlOverflow;
    };
  }, []);

  return (
    <>
      <GoogleAnalytics />
      <Provider store={store}>
        <ThemeProvider theme={defaultTheme}>
          <PubDocsRouter>
            <PubDocsRoutes />
          </PubDocsRouter>
        </ThemeProvider>
      </Provider>
    </>
  );
};
